import { InfoCard } from "./infoCard/infoCard";
import styles from "./linksSection.module.scss";
import { VenueHeader } from "./venueHeader";
import ScanButton from "../common/scanButton/scanButton";

export function LinksSection() {

  return (
    <div className={styles.container}>
      <div>
        {/* <GetTicketsNowButton /> */}
        <ScanButton red />
      </div>
      <VenueHeader />
      <div className={styles.cardsContainer}>
        {infoCards.map((cardProps) => (
            <InfoCard key={cardProps.ctaLabel} {...cardProps} />
          ))}
      </div>
      {/* <img src={`/bg/players-bg.png`} alt="" className={styles.bgImage} /> */}
    </div>
  );
}

const infoCards = [
  //   {
  //     imgSrc: "",
  //     altText: "",
  //     ctaLabel: "",
  //     ctaUrl: "",
  //     description: "",
  //   },
  {
    imgSrc: "social/tickets.png",
    altText: "Get Final8 Tickets",
    ctaLabel: "Tickets",
    ctaUrl: "https://www.showpass.com/usportsmbbfinal8/",
    description:
      "",
  },
  {
    imgSrc: "social/oval.jpg",
    altText: "Get Directions",
    ctaLabel: "Directions",
    ctaUrl: "https://godinos.com/facilities/jack-simpson-gym/2",
    description:
      "",
  },
  {
    imgSrc: "social/mens-bball.webp",
    altText: "Shop Dinos Merch",
    ctaLabel: "Shop Dinos Merch",
    ctaUrl: "https://shop.ucalgary.ca/Catalogue/ucalgary/clothing/dinos",
    description:
      "",
  },
  {
    imgSrc: "social/sports.png",
    altText: "Shop USports Merch",
    ctaLabel: "Shop USports Merch",
    ctaUrl: "https://shop.usports.ca/",
    description:
      "",
  },
  
];
